// extracted by mini-css-extract-plugin
export default {"svg":"Logo_svg__9nY+L"};